<template>
  <b-card class="no-border animated">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">{{displayName}} <span class="text-danger">({{userType}})</span> <b-badge pill variant="success" v-if="getUserType">{{getUserType}}</b-badge></h5>
      <div class="pull-right" v-if="section === ''">
        <b-button v-if="canEdit" variant="outline-primary" @click="section = 'edit'"><i class="fa fa-pencil-square-o"></i>&nbsp; Edit</b-button>
      </div>
    </div>
    <div class="list-group mb-2">
      <b-nav>
        <b-nav-item @click="section = ''"           :active="section === ''"                   >Preview</b-nav-item>
        <b-nav-item @click="section = 'update_password'" :active="section === 'update_password'">Update Password</b-nav-item>
      </b-nav>
    </div>
    <router-view></router-view>
  </b-card>
</template>
<script>
import userMixin from '@/mixins/user';
import { isEmpty, capitalize } from 'lodash';

export default {
  name: 'user_detail',
  mixins: [userMixin],
  data() {
    const routes = this.$route.fullPath.split('/');
    return {
      section: routes[4] || '',
      loaded: false,
    };
  },
  created() {
    // const { userId } = this.$route.params;
    this.$store.commit('users/SET_DETAIL_ID', this.getId);
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'profile', name: 'Profile' },
    ]);
  },
  computed: {
    detailedInfo() {
      return this.$store.getters['users/get_detail_data'];
    },
    displayName() {
      return this.detailedInfo.full_name;
    },
    userType() {
      const { type } = this.detailedInfo;
      switch (type) {
        case 'SYSTEM_ADMIN':
          return 'System Admin';
        case 'ADMIN':
          return 'Admin';
        default:
          return 'User';
      }
    },
    isAdmin() {
      return this.detailedInfo.type === 'ADMIN' ||
        this.detailedInfo.type === 'SYSTEM_ADMIN';
    },
    canImpersonate() {
      return !this.$store.getters.impersonating &&
        this.amISuperior(this.detailedInfo);
    },
    canEdit() {
      return this.amISuperior(this.detailedInfo);
    },
    getUserType() {
      const { employee, vehicle } = this.detailedInfo;
      let type = false;

      if (!isEmpty(employee) || !isEmpty(vehicle)) {
        type = isEmpty(vehicle) ? capitalize(employee.type) : 'Vehicle';
        if (type !== 'Loader' && type !== 'Driver' && type !== 'Vehicle') type = false;
      }

      return type;
    },
    getId() {
      return this.$store.getters.userData.id;
    },
  },
  watch: {
    section(newSection) {
      // const { userId } = this.$route.params;
      this.$router.push(`/profile/${newSection}`);
    },
  },
  methods: {
  },
};
</script>
<style>

</style>




// WEBPACK FOOTER //
// src/views/pages/profile/Detail.vue